export const teethSideOptions = [
  {
    value: 'I',
    label: 'I'
  },
  {
    value: 'Pa',
    label: 'Pa'
  },
  {
    value: 'La',
    label: 'La'
  },
  {
    value: 'M',
    label: 'M'
  },
  {
    value: 'D',
    label: 'D'
  },
  {
    value: 'O',
    label: 'O'
  },
  {
    value: 'Li',
    label: 'Li'
  },
  {
    value: 'B',
    label: 'B'
  },
]

export const teethOptions = [
    {
        "value": "11",
        "label": "11"
    },
    {
        "value": "12",
        "label": "12"
    },
    {
        "value": "13",
        "label": "13"
    },
    {
        "value": "14",
        "label": "14"
    },
    {
        "value": "15",
        "label": "15"
    },
    {
        "value": "16",
        "label": "16"
    },
    {
        "value": "17",
        "label": "17"
    },
    {
        "value": "18",
        "label": "18"
    },
    {
        "value": "21",
        "label": "21"
    },
    {
        "value": "22",
        "label": "22"
    },
    {
        "value": "23",
        "label": "23"
    },
    {
        "value": "24",
        "label": "24"
    },
    {
        "value": "25",
        "label": "25"
    },
    {
        "value": "26",
        "label": "26"
    },
    {
        "value": "27",
        "label": "27"
    },
    {
        "value": "28",
        "label": "28"
    },
    {
        "value": "31",
        "label": "31"
    },
    {
        "value": "32",
        "label": "32"
    },
    {
        "value": "33",
        "label": "33"
    },
    {
        "value": "34",
        "label": "34"
    },
    {
        "value": "35",
        "label": "35"
    },
    {
        "value": "36",
        "label": "36"
    },
    {
        "value": "37",
        "label": "37"
    },
    {
        "value": "38",
        "label": "38"
    },
    {
        "value": "41",
        "label": "41"
    },
    {
        "value": "42",
        "label": "42"
    },
    {
        "value": "43",
        "label": "43"
    },
    {
        "value": "44",
        "label": "44"
    },
    {
        "value": "45",
        "label": "45"
    },
    {
        "value": "46",
        "label": "46"
    },
    {
        "value": "47",
        "label": "47"
    },
    {
        "value": "48",
        "label": "48"
    },
    {
        "value": "51",
        "label": "51"
    },
    {
        "value": "52",
        "label": "52"
    },
    {
        "value": "53",
        "label": "53"
    },
    {
        "value": "54",
        "label": "54"
    },
    {
        "value": "55",
        "label": "55"
    },
    {
        "value": "61",
        "label": "61"
    },
    {
        "value": "62",
        "label": "62"
    },
    {
        "value": "63",
        "label": "63"
    },
    {
        "value": "64",
        "label": "64"
    },
    {
        "value": "65",
        "label": "65"
    },
    {
        "value": "71",
        "label": "71"
    },
    {
        "value": "72",
        "label": "72"
    },
    {
        "value": "73",
        "label": "73"
    },
    {
        "value": "74",
        "label": "74"
    },
    {
        "value": "75",
        "label": "75"
    },
    {
        "value": "81",
        "label": "81"
    },
    {
        "value": "82",
        "label": "82"
    },
    {
        "value": "83",
        "label": "83"
    },
    {
        "value": "84",
        "label": "84"
    },
    {
        "value": "85",
        "label": "85"
    },
    {
      value: 'Upper Right',
      label: 'Upper Right'
    },
    {
      value: 'Upper Left',
      label: 'Upper Left'
    },
    {
      value: 'Lower Right',
      label: 'Lower Right'
    },
    {
      value: 'Lower Left',
      label: 'Lower Left'
    },
    {
      value: 'Upper',
      label: 'Upper'
    },
    {
      value: 'Lower',
      label: 'Lower'
    },
    {
      value: 'Right',
      label: 'Right'
    },
    {
      value: 'Left',
      label: 'Left'
    },
    {
      value: 'Full Mouth',
      label: 'Full Mouth'
    },
    {
        "value": "supernumerary",
        "label": "Supernumerary"
    },
]
